export const en = {
  'nav.home': 'Home',
  'nav.plans': 'Memberships',
  'nav.classes': 'Classes',
  'nav.trainers': 'Trainers',
  'nav.contact': 'Contact',
  'nav.login': 'Sign in',
  'nav.register': 'Join',
  'nav.myAccount': 'My account',
  'nav.admin': 'Admin',
  'nav.logout': 'Sign out',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.create': 'Create',
  'common.search': 'Search',
  'common.loading': 'Loading…',
  'common.nothingYet': 'Nothing here yet',
  'common.error': 'Something went wrong',
  'common.retry': 'Try again',
  'common.confirm': 'Confirm',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.status': 'Status',
  'common.actions': 'Actions',
  'common.from': 'From',
  'common.to': 'To',
  'common.name': 'Name',
  'common.email': 'Email',
  'common.phone': 'Phone',
  'common.date': 'Date',
  'common.price': 'Price',
  'common.perMonth': 'per month',
  'common.days': 'days',
  'common.close': 'Close',
  'common.previous': 'Previous',
  'common.optional': 'Optional',
  'common.loadingLabel': 'Loading',
  'common.pagination': 'Page {page} of {pages} · {total} total',
  'common.loadMore': 'Load more',
  'common.feedCount': 'Showing {shown} of {total}',
  'plans.buy': 'Buy membership',
  'plans.perDays': '{days} days',
  'plans.classesIncluded': 'Group classes included',
  'plans.noClasses': 'Gym floor only',
  'plans.paymentsUnavailable': 'Online payments are not available at this gym yet. Please buy your membership at the front desk.',
  'plans.purchasesPaused': 'Online purchases are paused',
  'plans.purchasesPausedHint': 'This gym is not selling memberships online at the moment. The front desk can sign you up.',
  'classes.book': 'Book',
  'classes.booked': 'Booked',
  'classes.waitlist': 'Join waitlist',
  'classes.waitlisted': 'On waitlist',
  'classes.full': 'Full',
  'classes.spotsLeft': '{n} spots left',
  'classes.cancelBooking': 'Cancel booking',
  'classes.allBranches': 'All branches',
  'classes.filterBranch': 'Filter by branch',
  'contact.send': 'Send message',
  'contact.sent': 'Thanks, we will get back to you shortly.',
  'contact.message': 'Message',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.firstName': 'First name',
  'auth.lastName': 'Last name',
  'auth.signIn': 'Sign in',
  'auth.createAccount': 'Create account',
  'auth.noAccount': 'No account yet?',
  'auth.haveAccount': 'Already a member?',
  'offersStop.title': 'Stop offers by email?',
  'offersStop.text': 'The gym will no longer email you offers. Service emails about your membership and bookings still come.',
  'offersStop.confirm': 'Stop offers by email',
  'offersStop.done': 'You will get no more offers by email from {gym}.',
  'offersStop.doneHint': 'You can switch them back on in your profile.',
  'offersStop.notFound': 'This link does not work. To stop offers, untick them in your profile.',
  'member.dashboard': 'Dashboard',
  'member.membership': 'Membership',
  'member.payments': 'Payments',
  'member.bookings': 'My bookings',
  'member.profile': 'Profile',
  'member.smsNotifications': 'Text me about my classes and membership',
  'member.smsNotificationsHint': 'We also send an SMS when a class you booked is cancelled or changed, when your membership is about to end or its renewal fails, and with your sign-in link.',
  'member.smsOffers': 'Send me offers and discounts by SMS',
  'member.smsOffersHint': 'Say no at any time: untick this, or reply as the last line of each offer says. Your answer is kept on record.',
  'member.emailOffers': 'Send me offers and discounts by email',
  'member.emailOffersHint': 'Say no at any time: untick this, or use the link at the end of each offer. Your answer is kept on record.',
  'member.access': 'Access history',
  'member.notifications': 'Notifications',
  'member.documents': 'Documents',
  'access.live.title': 'Live',
  'access.live.instant': 'Instant updates',
  'access.live.polling': 'Refreshes every 5s',
  'access.live.insideNow': 'Inside now',
  'access.live.entriesToday': 'Entries today',
  'access.live.deniedToday': 'Denied today',
  'access.live.empty': 'No taps yet. Cards appear here the moment someone reaches a lane.',
  'access.live.daysLeft': '{n} days left',
  'access.live.oneDayLeft': '1 day left',
  'access.live.lastDay': 'Last day',
  'access.live.expired': 'Expired',
  'access.live.paused': 'Paused',
  'access.live.pending': 'Awaiting payment',
  'access.live.noMembership': 'No membership',
  'access.live.unknownCard': 'Unknown card',
  'access.live.entered': 'In',
  'access.live.left': 'Out',
  'access.live.denied': 'Denied',
  'access.live.open': 'Live feed',
  'shell.nav.overview': 'Overview',
  'shell.nav.dashboard': 'Dashboard',
  'shell.nav.frontDesk': 'Front desk',
  'shell.nav.memberships': 'Memberships',
  'shell.nav.members': 'Members',
  'shell.nav.plans': 'Plans',
  'shell.nav.classes': 'Classes',
  'shell.nav.sessions': 'Sessions',
  'shell.nav.bookings': 'Bookings',
  'shell.nav.trainers': 'Trainers',
  'shell.nav.specialties': 'Specialities',
  'shell.nav.segments': 'Tags and segments',
  'shell.nav.rooms': 'Rooms',
  'shell.nav.payments': 'Payments',
  'shell.nav.access': 'Access',
  'shell.nav.accessControl': 'Access control',
  'shell.nav.finance': 'Finance',
  'shell.nav.ledger': 'Ledger',
  'shell.nav.expenses': 'Expenses',
  'shell.nav.profit': 'Profit',
  'shell.nav.financeCharts': 'Charts',
  'financeCharts.description': 'Boards of charts over the money: build your own, or share one with the team.',
  'shell.nav.reports': 'Reports',
  'shell.nav.refunds': 'Refunds',
  'shell.nav.dailyReport': 'Daily report',
  'shell.nav.deadlines': 'Deadlines',
  'shell.nav.website': 'Website',
  'shell.nav.campaigns': 'Campaigns',
  'shell.nav.menu': 'Menu',
  'shell.nav.documents': 'Documents',
  'shell.nav.legalPages': 'Legal pages',
  'shell.nav.team': 'Team',
  'shell.nav.employees': 'Employees',
  'shell.nav.leaveSettings': 'Leave settings',
  'shell.nav.leave': 'Leave',
  'shell.nav.approvals': 'Approvals',
  'shell.nav.myPay': 'My pay',
  'shell.nav.waiting': '{count} waiting',
  'shell.nav.payroll': 'Payroll',
  'shell.nav.timesheets': 'Timesheets',
  'shell.nav.gym': 'Gym',
  'shell.nav.staff': 'Staff',
  'shell.nav.roleAbilities': 'Roles and permissions',
  'shell.nav.integrations': 'Integrations',
  'shell.nav.settings': 'Settings',
  'shell.nav.audit': 'Audit log',
  'shell.goHome': 'Go to dashboard',
  'shell.collapse': 'Collapse sidebar',
  'shell.expand': 'Expand sidebar',
  'shell.openNav': 'Open navigation',
  'shell.switchGym': 'Switch gym',
  'shell.nav.practice': 'Practice gym',
  'practice.label': 'Practice',
  'shell.accountMenu': 'Account menu',
  'shell.menu.settings': 'Personal settings',
  'shell.menu.publicSite': 'Public website',
  'shell.switchTo': 'Switch to',
  'shell.app.admin': 'Gym admin',
  'shell.app.member': 'Member area',
  'shell.app.platform': 'Platform console',
  'shell.menu.theme': 'Theme',
  'settings.title': 'Personal settings',
  'settings.description': 'How Bulk looks and speaks for you, on every device you sign in on.',
  'settings.appearance': 'Appearance',
  'settings.appearanceHint': 'System follows your device and switches with it.',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.theme.system': 'System',
  'settings.language': 'Language',
  'settings.languageHint': 'Menus, pages and messages. A few messages that come from the server are still in English.',
  'settings.profile': 'Profile',
  'settings.saved': 'Saved',
  'settings.password': 'Password',
  'settings.currentPassword': 'Current password',
  'settings.newPassword': 'New password',
  'settings.confirmPassword': 'Repeat the new password',
  'settings.changePassword': 'Change password',
  'settings.passwordChanged': 'Password changed',
  'settings.passwordMismatch': 'The two passwords do not match',
  'settings.emailReadOnly': 'Your email is your sign-in and cannot be changed here.',
  'member.pause': 'Pause membership',
  'member.resume': 'Resume membership',
  'member.renew': 'Renew',
  'member.noMembership': 'You do not have an active membership.',
  'member.row.upcoming': 'Upcoming',
  'member.row.startsIn.one': 'starts in {count} day',
  'member.row.startsIn.other': 'starts in {count} days',
  'member.row.pauses.one': '{count} pause',
  'member.row.pauses.other': '{count} pauses',
  'member.row.pausedDays.one': '{count} day',
  'member.row.pausedDays.other': '{count} days',
  'member.row.autoRenews': 'Renews automatically',
  'member.row.pausedSince': 'Paused since {date}',
  'member.row.reason': 'Reason: {reason}',
  'member.row.autoRenewSwitch': 'Renew automatically with my saved card',
  'member.row.autoRenewOn': 'Automatic renewal is on',
  'member.row.autoRenewOnHint': 'We will charge your saved card a few days before the end date.',
  'member.row.autoRenewOff': 'Automatic renewal is off',
  'member.row.autoRenewOffHint': 'Your card will not be charged for this membership.',
  'member.row.completePayment': 'Complete payment',
  'member.row.waitingFor': 'Waiting for {company}’s payment',
  'member.row.paidBy': 'Paid by {company}',
  'member.row.history': 'History',
  'membership.status.ACTIVE': 'Active',
  'membership.status.PENDING': 'Pending payment',
  'membership.status.PAUSED': 'Paused',
  'membership.status.EXPIRED': 'Expired',
  'membership.status.CANCELLED': 'Cancelled',
  'membership.status.SUSPENDED': 'Suspended',
  'control.pickDate': 'Pick a date',
  'control.pickTime': 'Pick a time',
  'control.hour': 'Hour',
  'control.minute': 'Minute',
  'control.clear': 'Clear',
  'control.clearSearch': 'Clear search',
  'control.noOptions': 'No options',
  'control.previousMonth': 'Previous month',
  'control.nextMonth': 'Next month',
  'control.chooseFile': 'Choose a file',
  'control.noFile': 'No file chosen',
  'control.showPassword': 'Show password',
  'control.hidePassword': 'Hide password',
  'control.increase': 'Increase',
  'control.decrease': 'Decrease',
  'control.hexColour': 'Hex colour',
  'control.dragHandle': 'Drag to reorder',
  'control.dragInstructions': 'To pick up an item, press Space or Enter. Move it with the arrow keys, press Space or Enter again to drop it, or Escape to cancel.',
  'control.dragPicked': 'Picked up item {position} of {total}.',
  'control.dragMoved': 'Moved to position {position} of {total}.',
  'control.dragDropped': 'Dropped at position {position} of {total}.',
  'control.dragCancelled': 'Moving cancelled.',
};

export const ka: Record<keyof typeof en, string> = {
  'nav.home': 'მთავარი',
  'nav.plans': 'აბონემენტები',
  'nav.classes': 'ჯგუფური ვარჯიშები',
  'nav.trainers': 'ტრენერები',
  'nav.contact': 'კონტაქტი',
  'nav.login': 'შესვლა',
  'nav.register': 'გაწევრიანება',
  'nav.myAccount': 'ჩემი ანგარიში',
  'nav.admin': 'ადმინი',
  'nav.logout': 'გასვლა',
  'common.save': 'შენახვა',
  'common.cancel': 'გაუქმება',
  'common.delete': 'წაშლა',
  'common.edit': 'რედაქტირება',
  'common.create': 'შექმნა',
  'common.search': 'ძებნა',
  'common.loading': 'იტვირთება…',
  'common.nothingYet': 'ჯერ არაფერია',
  'common.error': 'რაღაც არასწორად წავიდა',
  'common.retry': 'სცადეთ თავიდან',
  'common.confirm': 'დადასტურება',
  'common.yes': 'დიახ',
  'common.no': 'არა',
  'common.back': 'უკან',
  'common.next': 'შემდეგი',
  'common.status': 'სტატუსი',
  'common.actions': 'მოქმედებები',
  'common.from': 'დან',
  'common.to': 'მდე',
  'common.name': 'სახელი',
  'common.email': 'ელფოსტა',
  'common.phone': 'ტელეფონი',
  'common.date': 'თარიღი',
  'common.price': 'ფასი',
  'common.perMonth': 'თვეში',
  'common.days': 'დღე',
  'common.close': 'დახურვა',
  'common.previous': 'წინა',
  'common.optional': 'არასავალდებულო',
  'common.loadingLabel': 'იტვირთება',
  'common.pagination': 'გვერდი {page} / {pages} · სულ {total}',
  'common.loadMore': 'მეტის ჩატვირთვა',
  'common.feedCount': 'ნაჩვენებია {shown} / {total}',
  'plans.buy': 'აბონემენტის შეძენა',
  'plans.perDays': '{days} დღე',
  'plans.classesIncluded': 'ჯგუფური ვარჯიშები შედის',
  'plans.noClasses': 'მხოლოდ დარბაზი',
  'plans.paymentsUnavailable': 'ონლაინ გადახდა ამ დარბაზში ჯერ მიუწვდომელია. გთხოვთ, აბონემენტი შეიძინეთ რეცეფციაზე.',
  'plans.purchasesPaused': 'ონლაინ შეძენა დროებით შეჩერებულია',
  'plans.purchasesPausedHint': 'ამჟამად აბონემენტები ონლაინ არ იყიდება. გადახდა შეგიძლიათ რეცეფციაზე.',
  'classes.book': 'დაჯავშნა',
  'classes.booked': 'დაჯავშნილია',
  'classes.waitlist': 'მოლოდინის სიაში ჩაწერა',
  'classes.waitlisted': 'მოლოდინის სიაში',
  'classes.full': 'სავსეა',
  'classes.spotsLeft': 'დარჩა {n} ადგილი',
  'classes.cancelBooking': 'ჯავშნის გაუქმება',
  'classes.allBranches': 'ყველა ფილიალი',
  'classes.filterBranch': 'ფილიალის არჩევა',
  'contact.send': 'გაგზავნა',
  'contact.sent': 'მადლობა, მალე დაგიკავშირდებით.',
  'contact.message': 'შეტყობინება',
  'auth.email': 'ელფოსტა',
  'auth.password': 'პაროლი',
  'auth.firstName': 'სახელი',
  'auth.lastName': 'გვარი',
  'auth.signIn': 'შესვლა',
  'auth.createAccount': 'ანგარიშის შექმნა',
  'auth.noAccount': 'ჯერ არ გაქვთ ანგარიში?',
  'auth.haveAccount': 'უკვე წევრი ხართ?',
  'offersStop.title': 'შეწყდეს შეთავაზებები ელფოსტით?',
  'offersStop.text': 'დარბაზი აღარ გამოგიგზავნით შეთავაზებებს ელფოსტით. სერვისული წერილები აბონემენტისა და ჯავშნების შესახებ კვლავ მოგივათ.',
  'offersStop.confirm': 'შეთავაზებების შეწყვეტა ელფოსტით',
  'offersStop.done': 'დარბაზისგან „{gym}“ შეთავაზებებს ელფოსტით აღარ მიიღებთ.',
  'offersStop.doneHint': 'მათი ხელახლა ჩართვა შეგიძლიათ თქვენს პროფილში.',
  'offersStop.notFound': 'ეს ბმული არ მუშაობს. შეთავაზებების შესაწყვეტად მოხსენით მონიშვნა თქვენს პროფილში.',
  'member.dashboard': 'მთავარი',
  'member.membership': 'აბონემენტი',
  'member.payments': 'გადახდები',
  'member.bookings': 'ჩემი ჯავშნები',
  'member.profile': 'პროფილი',
  'member.smsNotifications': 'SMS ჩემი ვარჯიშებისა და აბონემენტის შესახებ',
  'member.smsNotificationsHint': 'SMS-საც გამოგიგზავნით, როცა დაჯავშნილი ვარჯიში გაუქმდება ან შეიცვლება, როცა აბონემენტს ვადა ეწურება ან მისი განახლება ვერ მოხერხდება, და შესვლის ბმულსაც.',
  'member.smsOffers': 'გამომიგზავნეთ შეთავაზებები და ფასდაკლებები SMS-ით',
  'member.smsOffersHint': 'უარის თქმა ნებისმიერ დროს შეგიძლიათ: მოხსენით ეს მონიშვნა ან უპასუხეთ ისე, როგორც ყოველი შეთავაზების ბოლო ხაზი გეტყვით. თქვენი პასუხი ინახება.',
  'member.emailOffers': 'გამომიგზავნეთ შეთავაზებები და ფასდაკლებები ელფოსტით',
  'member.emailOffersHint': 'უარის თქმა ნებისმიერ დროს შეგიძლიათ: მოხსენით ეს მონიშვნა ან გამოიყენეთ ყოველი შეთავაზების ბოლოს მითითებული ბმული. თქვენი პასუხი ინახება.',
  'member.access': 'შესვლების ისტორია',
  'member.notifications': 'შეტყობინებები',
  'member.documents': 'დოკუმენტები',
  'access.live.title': 'რეალურ დროში',
  'access.live.instant': 'მყისიერი განახლება',
  'access.live.polling': 'ახლდება ყოველ 5 წამში',
  'access.live.insideNow': 'ახლა შიგნით',
  'access.live.entriesToday': 'დღეს შემოვიდა',
  'access.live.deniedToday': 'დღეს უარი',
  'access.live.empty': 'შესვლები ჯერ არ არის. ბარათი აქ გამოჩნდება, როგორც კი ვინმე ტურნიკეტთან მივა.',
  'access.live.daysLeft': 'დარჩა {n} დღე',
  'access.live.oneDayLeft': 'დარჩა 1 დღე',
  'access.live.lastDay': 'ბოლო დღე',
  'access.live.expired': 'ვადაგასული',
  'access.live.paused': 'შეჩერებული',
  'access.live.pending': 'ელოდება გადახდას',
  'access.live.noMembership': 'აბონემენტი არ აქვს',
  'access.live.unknownCard': 'უცნობი ბარათი',
  'access.live.entered': 'შესვლა',
  'access.live.left': 'გასვლა',
  'access.live.denied': 'უარი',
  'access.live.open': 'შესვლები რეალურ დროში',
  'shell.nav.overview': 'მიმოხილვა',
  'shell.nav.dashboard': 'მთავარი დაფა',
  'shell.nav.frontDesk': 'მიმღები',
  'shell.nav.memberships': 'აბონემენტები',
  'shell.nav.members': 'წევრები',
  'shell.nav.plans': 'პაკეტები',
  'shell.nav.classes': 'ვარჯიშები',
  'shell.nav.sessions': 'სესიები',
  'shell.nav.bookings': 'ჯავშნები',
  'shell.nav.trainers': 'ტრენერები',
  'shell.nav.specialties': 'სპეციალობები',
  'shell.nav.segments': 'ტეგები და სეგმენტები',
  'shell.nav.rooms': 'ოთახები',
  'shell.nav.payments': 'გადახდები',
  'shell.nav.access': 'დაშვება',
  'shell.nav.accessControl': 'დაშვების კონტროლი',
  'shell.nav.finance': 'ფინანსები',
  'shell.nav.ledger': 'რეესტრი',
  'shell.nav.expenses': 'ხარჯები',
  'shell.nav.profit': 'მოგება',
  'shell.nav.financeCharts': 'დიაგრამები',
  'financeCharts.description': 'ფინანსების დიაგრამების დაფები: ააწყვეთ საკუთარი ან გაუზიარეთ გუნდს.',
  'shell.nav.reports': 'ანგარიშები',
  'shell.nav.refunds': 'დაბრუნებები',
  'shell.nav.dailyReport': 'დღის ანგარიში',
  'shell.nav.deadlines': 'ვადები',
  'shell.nav.website': 'ვებსაიტი',
  'shell.nav.campaigns': 'აქციები',
  'shell.nav.menu': 'მენიუ',
  'shell.nav.documents': 'დოკუმენტები',
  'shell.nav.legalPages': 'იურიდიული გვერდები',
  'shell.nav.team': 'გუნდი',
  'shell.nav.employees': 'თანამშრომლები',
  'shell.nav.leaveSettings': 'შვებულების წესები',
  'shell.nav.leave': 'შვებულება',
  'shell.nav.approvals': 'დასამტკიცებელი',
  'shell.nav.myPay': 'ჩემი ხელფასი',
  'shell.nav.waiting': '{count} ელოდება',
  'shell.nav.payroll': 'ხელფასები',
  'shell.nav.timesheets': 'სამუშაო საათები',
  'shell.nav.gym': 'დარბაზი',
  'shell.nav.staff': 'პერსონალი',
  'shell.nav.roleAbilities': 'როლები და უფლებები',
  'shell.nav.integrations': 'ინტეგრაციები',
  'shell.nav.settings': 'პარამეტრები',
  'shell.nav.audit': 'აუდიტის ჟურნალი',
  'shell.goHome': 'მთავარ დაფაზე გადასვლა',
  'shell.collapse': 'გვერდითა პანელის აკეცვა',
  'shell.expand': 'გვერდითა პანელის გაშლა',
  'shell.openNav': 'ნავიგაციის გახსნა',
  'shell.switchGym': 'დარბაზის შეცვლა',
  'shell.nav.practice': 'სავარჯიშო დარბაზი',
  'practice.label': 'სავარჯიშო',
  'shell.accountMenu': 'ანგარიშის მენიუ',
  'shell.menu.settings': 'პირადი პარამეტრები',
  'shell.menu.publicSite': 'საჯარო ვებსაიტი',
  'shell.switchTo': 'გადასვლა',
  'shell.app.admin': 'დარბაზის მართვა',
  'shell.app.member': 'წევრის კაბინეტი',
  'shell.app.platform': 'პლატფორმის კონსოლი',
  'shell.menu.theme': 'თემა',
  'settings.title': 'პირადი პარამეტრები',
  'settings.description': 'როგორ გამოიყურება და რა ენაზე გელაპარაკებათ Bulk ყველა მოწყობილობაზე, სადაც შეხვალთ.',
  'settings.appearance': 'იერსახე',
  'settings.appearanceHint': 'სისტემური მიჰყვება თქვენს მოწყობილობას და მასთან ერთად იცვლება.',
  'settings.theme.light': 'ღია',
  'settings.theme.dark': 'მუქი',
  'settings.theme.system': 'სისტემური',
  'settings.language': 'ენა',
  'settings.languageHint': 'მენიუები, გვერდები და შეტყობინებები. სერვერიდან მოსული ზოგი შეტყობინება ჯერ ინგლისურადაა.',
  'settings.profile': 'პროფილი',
  'settings.saved': 'შენახულია',
  'settings.password': 'პაროლი',
  'settings.currentPassword': 'მიმდინარე პაროლი',
  'settings.newPassword': 'ახალი პაროლი',
  'settings.confirmPassword': 'გაიმეორეთ ახალი პაროლი',
  'settings.changePassword': 'პაროლის შეცვლა',
  'settings.passwordChanged': 'პაროლი შეიცვალა',
  'settings.passwordMismatch': 'პაროლები არ ემთხვევა',
  'settings.emailReadOnly': 'ელფოსტა თქვენი შესვლის მონაცემია და აქ ვერ შეიცვლება.',
  'member.pause': 'აბონემენტის დაპაუზება',
  'member.resume': 'აბონემენტის განახლება',
  'member.renew': 'გაგრძელება',
  'member.noMembership': 'აქტიური აბონემენტი არ გაქვთ.',
  'member.row.upcoming': 'მომავალი',
  'member.row.startsIn.one': 'იწყება {count} დღეში',
  'member.row.startsIn.other': 'იწყება {count} დღეში',
  'member.row.pauses.one': '{count} პაუზა',
  'member.row.pauses.other': '{count} პაუზა',
  'member.row.pausedDays.one': '{count} დღე',
  'member.row.pausedDays.other': '{count} დღე',
  'member.row.autoRenews': 'ავტომატურად განახლდება',
  'member.row.pausedSince': 'დაპაუზებულია {date}-დან',
  'member.row.reason': 'მიზეზი: {reason}',
  'member.row.autoRenewSwitch': 'ავტომატური განახლება ჩემი შენახული ბარათით',
  'member.row.autoRenewOn': 'ავტომატური განახლება ჩართულია',
  'member.row.autoRenewOnHint': 'შენახული ბარათიდან თანხას ვადის ამოწურვამდე რამდენიმე დღით ადრე ჩამოვაჭრით.',
  'member.row.autoRenewOff': 'ავტომატური განახლება გამორთულია',
  'member.row.autoRenewOffHint': 'ამ აბონემენტისთვის თქვენს ბარათს თანხა არ ჩამოეჭრება.',
  'member.row.completePayment': 'გადახდის დასრულება',
  'member.row.waitingFor': 'ელოდება „{company}“-ის გადახდას',
  'member.row.paidBy': 'გადახდილია „{company}“-ის მიერ',
  'member.row.history': 'ისტორია',
  'membership.status.ACTIVE': 'აქტიური',
  'membership.status.PENDING': 'გადახდის მოლოდინში',
  'membership.status.PAUSED': 'დაპაუზებული',
  'membership.status.EXPIRED': 'ვადაგასული',
  'membership.status.CANCELLED': 'გაუქმებული',
  'membership.status.SUSPENDED': 'შეჩერებული',
  'control.pickDate': 'აირჩიეთ თარიღი',
  'control.pickTime': 'აირჩიეთ დრო',
  'control.hour': 'საათი',
  'control.minute': 'წუთი',
  'control.clear': 'გასუფთავება',
  'control.clearSearch': 'ძიების გასუფთავება',
  'control.noOptions': 'ვარიანტები არ არის',
  'control.previousMonth': 'წინა თვე',
  'control.nextMonth': 'შემდეგი თვე',
  'control.chooseFile': 'ფაილის არჩევა',
  'control.noFile': 'ფაილი არჩეული არ არის',
  'control.showPassword': 'პაროლის ჩვენება',
  'control.hidePassword': 'პაროლის დამალვა',
  'control.increase': 'გაზრდა',
  'control.decrease': 'შემცირება',
  'control.hexColour': 'ფერის Hex კოდი',
  'control.dragHandle': 'გადაიტანეთ რიგის შესაცვლელად',
  'control.dragInstructions': 'ასაღებად დააჭირეთ Space-ს ან Enter-ს. გადაადგილეთ ისრებით, დასადებად კვლავ დააჭირეთ Space-ს ან Enter-ს, გასაუქმებლად კი Escape-ს.',
  'control.dragPicked': 'აღებულია ელემენტი {position} / {total}.',
  'control.dragMoved': 'გადატანილია პოზიციაზე {position} / {total}.',
  'control.dragDropped': 'დადებულია პოზიციაზე {position} / {total}.',
  'control.dragCancelled': 'გადატანა გაუქმდა.',
};
